import { verifyUser, sendPasswordResetEmail } from "../../api";
import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Button from "react-bootstrap/Button";
import axios from "axios";
import logo from "../../Resources/Transparent_Logo.png"; // Mobile logo
import logo1 from "../../Resources/Transparent_Logo1.png"; // Desktop logo (200% larger)
import React from "react";
import "./login.css";

export function LoginYt() {
  const navigate = useNavigate();
  const location = useLocation();

  const [user, setUser] = useState({
    email: "",
    password: "",
  });

  const [error, setError] = useState("");
  const [forgotPassword, setForgotPassword] = useState(false);
  const [resetEmailSent, setResetEmailSent] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  // Extract the `redirect` query parameter or use "/home" as the default
  const redirect =
    new URLSearchParams(location.search).get("redirect") || "/home";

  // Handle input changes
  function handleChange(e) {
    setUser({ ...user, [e.target.name]: e.target.value });
  }

  // Handle form submission
 async function handleSubmit(e) {
  e.preventDefault();
  setError("");
  setIsLoading(true);

  // Lock redirect to internal routes only (prevents open-redirect)
  const redirectParam = new URLSearchParams(location.search).get("redirect");
  const safeRedirect =
    redirectParam && redirectParam.startsWith("/") ? redirectParam : "/home";

  // --- Forgot password flow ---
  if (forgotPassword) {
    if (!user.email) {
      setError("Please enter your email address");
      setIsLoading(false);
      return;
    }

    try {
      // ✅ Call API first, then show success UI
      await sendPasswordResetEmail(user.email);

      // ✅ Always show generic success message (avoid account enumeration)
      setResetEmailSent(true);
      setError("");
    } catch (err) {
      console.error("⛔ Error during password reset request:", err);

      // Still keep message generic; don't reveal whether email exists
      setError("An error occurred. Please try again later.");
      setResetEmailSent(false);
    } finally {
      setIsLoading(false);
    }
    return;
  }

  // --- Login flow ---
  try {
  const result = await verifyUser(user); // { success, token }

if (!result?.success || !result?.token) {
  setError(result?.message || "Invalid credentials. Please try again.");
  setIsLoading(false);
  return;
}

sessionStorage.setItem("user", result.token); // ✅ keep your existing key
axios.defaults.headers.common["authorization"] = `Bearer ${result.token}`;
navigate(safeRedirect, { replace: true });


} catch (err) {
  console.error("⛔ Error during login:", err);
  setError("An error occurred. Please try again later.");
} finally {
  setIsLoading(false);
}
}


  // Toggle between login and forgot password modes
  function toggleForgotPassword() {
    setForgotPassword(!forgotPassword);
    setError("");
    setResetEmailSent(false);
  }

  return (
    <Container fluid style={{ height: "100vh" }}>
      <Row className="h-100 flex-column flex-md-row">
        {/* Logo Section */}
        <Col
          xs={12} // Full width on mobile
          md={6} // Left half on desktop
          className="d-flex align-items-center justify-content-center bg-white"
          style={{ minHeight: "33vh" }} // Ensure one-third height on mobile
        >
          {/* Mobile Logo */}
          <img
            src={logo}
            alt="Mobile Logo"
            className="img-fluid d-block d-md-none logo-mobile"
          />

          {/* Desktop Logo (200% bigger) */}
          <img
            src={logo1}
            alt="Desktop Logo"
            className="img-fluid d-none d-md-block logo-desktop"
          />
        </Col>

        {/* Form Section */}
        <Col
          xs={12} // Full width on mobile
          md={6} // Right half on desktop
          className="d-flex align-items-center justify-content-center bg-primary text-white"
          style={{ minHeight: "67vh" }} // Ensure two-thirds height on mobile
        >
          <Container
            className="container-fluid d-flex justify-content-center align-items-center mt-3 me-3 mb-3 ms-3 pb-3 pt-3 shadow border border-white rounded"
            style={{ maxWidth: "90%" }}
          >
            <Form className="w-100" onSubmit={handleSubmit}>
              {resetEmailSent ? (
                // Show success message when reset email is sent
                <div className="text-center mb-4">
                  <p className="mb-3">
                    An email will be sent to your account to change your
                    password.
                  </p>
                  <Button
                    variant="secondary"
                    onClick={toggleForgotPassword}
                    className="text-white"
                  >
                    Back to Login
                  </Button>
                </div>
              ) : (
                // Show login form or forgot password form
                <>
                  <h4 className="mb-4 text-center">
                    {forgotPassword ? "Reset Password" : "Login"}
                  </h4>

                  <Form.Group
                    className="mb-3 ms-3 me-3"
                    controlId="formBasicEmail"
                  >
                    <Form.Label className="text-start d-block">
                      Email address
                    </Form.Label>
                    <Form.Control
                      type="email"
                      className="w-100"
                      placeholder="Enter email"
                      onChange={handleChange}
                      name="email"
                      value={user.email}
                      required
                    />
                  </Form.Group>

                  {!forgotPassword && (
                    <Form.Group
                      className="mb-1 ms-3 me-3"
                      controlId="formBasicPassword"
                    >
                      <Form.Label className="text-start d-block">
                        Password
                      </Form.Label>
                      <Form.Control
                        type="password"
                        className="w-100"
                        placeholder="Password"
                        onChange={handleChange}
                        name="password"
                        required
                      />
                    </Form.Group>
                  )}

                  {/* Error Message */}
                  {error && <p className="text-white ms-3">{error}</p>}

                  {/* Forgot Password Link - Now left-aligned */}
                  <div className="mb-3 ms-3 text-start">
                    <span
                      className="text-white text-decoration-underline"
                      style={{ cursor: "pointer" }}
                      onClick={toggleForgotPassword}
                    >
                      {forgotPassword ? "Back to Login" : "Forgot Password?"}
                    </span>
                  </div>

                  <div className="text-center">
                    <Button
                      variant="secondary"
                      type="submit"
                      className="text-white mt-3 w-25"
                      disabled={isLoading}
                    >
                      {isLoading ? (
                        <>
                          <span
                            className="spinner-border spinner-border-sm me-2"
                            role="status"
                            aria-hidden="true"
                          />
                          {forgotPassword ? "Sending..." : "Logging in..."}
                        </>
                      ) : forgotPassword ? (
                        "Reset Password"
                      ) : (
                        "Submit"
                      )}
                    </Button>
                  </div>
                </>
              )}
            </Form>
          </Container>
        </Col>
      </Row>
    </Container>
  );
}
